import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import React, { useEffect } from 'react';
import { trackPromise } from "react-promise-tracker";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import { GENERATOR_UNITS_RETRIEVED } from "src/store/energy-markets/energyMarketActionTypes";
import useStyles from "../../../Styles";
import axios from "../../../axios/AxiosInterceptors";
import { onError } from "../../../store/actions/popupActions";

const ViewGeneratorUnits = (props) => {

    const classes = useStyles(props);
    const dispatch = useDispatch();
    const params = useParams();
    const history = useHistory();

    const generatorUnits = useSelector(state => state.energyMarket.generatorUnits);

    useEffect(() => {
        doSearch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.accountId])

    const doSearch = async () => {
        await trackPromise(axios.get("/marketsgateway/v1/account/" + params.accountId + "/generation/unit").then(response => {
            dispatch({ type: GENERATOR_UNITS_RETRIEVED, generatorUnits: response.data });
        }).catch(error => {
            dispatch(onError(error));
        }))
    }

    const handleOnClick = async (generatorUnit) => {
        if (!generatorUnit.id) {
            await trackPromise(axios.post("/marketsgateway/v1/account/" + params.accountId + "/generation/unit", JSON.stringify(generatorUnit)).then(response => {
                history.push("/markets/account/" + params.accountId + "/energy/generator/unit/" + response.data.id);
            }).catch(error => {
                dispatch(onError(error));
            }))
        } else {
            history.push("/markets/account/" + params.accountId + "/energy/generator/unit/" + generatorUnit.id);
        }
    }

    return (
        <main className={classes.layout}>
            <React.Fragment>
                <Typography variant="h4" align="center"> Generation Units</Typography>
                <Table>
                    <TableHead sx={{ width: "max-content" }}>
                        <TableRow>
                            <TableCell>Unit Name</TableCell>
                            <TableCell>Location Id</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {generatorUnits && generatorUnits.length > 0 && generatorUnits.map(r => {
                            return (
                                <TableRow key={r.generatorId} className={classes.tableRow}
                                    onClick={() => handleOnClick(r)}>
                                    <TableCell>{r.unitName}</TableCell>
                                    <TableCell>{r.locationId}</TableCell>
                                </TableRow>
                            )
                        })
                        }
                    </TableBody>
                </Table>
            </React.Fragment>
        </main >
    )

}

export default ViewGeneratorUnits;